import { ASK_RECOVER_PASSWORD, RESET_RECOVER_PASSWORD } from '../types';

const initialState = {
  emailSent: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ASK_RECOVER_PASSWORD:
      return {
        ...state,
        emailSent: true,
      };
    case RESET_RECOVER_PASSWORD:
      return {
        ...state,
        emailSent: false,
      };
    default:
      return state;
  }
}
